import actionTypes from '../actionTypes';
import {
	INVENTORY_HEALTH,
	PRICING_CHANGE,
	POINTS_OF_DISTRIBUTION,
	PRICING,
	POD,
	ASSORTMENT,
} from '../../constants/constant';
import {
	ASSORTMENT_COLOUMNS,
	INVENTORY_COLUMNS,
	POD_COLUMNS,
	PRICING_COLUMNS,
} from './constants';

export const initialState = {
	rootCauses: [],
	tableRows: [],
	tableColumns: [],
	threshold: 95,
	hierarchyId: '',
	hierarchyName: '',
	currentRootCause: '',

	/*Top Tiles on the Page */
	supplier_share: 0,
	supplier_share_change: 0,

	net_sales: 0,
	net_sales_change: 0,
	net_sales_change_percent: 0,
	walmart_net_sales_change_percent: 0,

	units: 0,
	units_change: 0,
	units_change_percent: 0,
	walmart_units_change_percent: 0,

	avgNilPickPct: 0,
	wmNilPickRate: 0,

	/* Cards on the Inventory Root Cause */
	inventory_avg_instock_percent: 0,
	inventory_avg_nilpick_percent: 0,
	inventory_items_oos: 0,
	inventory_potential_sales_impact: 0,

	/* Inventory Rows and Columns - RCA Table */

	inventory_rows: [],
	inventory_columns: INVENTORY_COLUMNS,

	/* Cards on the Pricing Root Cause */
	pricing_increased_in_price: 0,
	pricing_decreased_in_price: 0,
	pricing_potional_sales_impact: 0,

	/* Pricing Rows and Columns */
	pricing_rows: [],
	pricing_columns: PRICING_COLUMNS,

	/* Cards on the Pricing Root Cause  */
	pod_increased_in_traited_stores: 0,
	pod_decreased_in_traited_stores: 0,
	pod_potential_sales_impact: 0,

	/* Pod Rows and Columns */
	pod_rows: [],
	pod_columns: POD_COLUMNS,

	/* Cards on the Assortment Root Cause  */
	assortment_added: 0,
	assortment_removed: 0,
	assortment_potential_sales_impact: 0,

	/* Assorment Rows and Columns */
	assortment_rows: [],
	assortment_columns: ASSORTMENT_COLOUMNS,

	/* Loading and error state for the whole page */
	loading: true,
	error: false,

	/* Loading and error state for updating replenishment Instock Percentage */
	repInStockLoading: false,
	replInstockError: false,
};

const updateInventoryColumns = (inventory_columns, threshold) => {
	return inventory_columns?.map((inventory_column) => {
		if (inventory_column.field === 'node.inStockPctTYAvg') {
			return {
				...inventory_column,
				headerName: `Stores with Rpl. InStock < ${threshold}%`,
			};
		}
		return inventory_column;
	});
};

const resetInventoryColumns = (inventory_columns) => {
	return inventory_columns?.map((inventory_column) => {
		if (inventory_column.field === 'node.inStockPctTYAvg') {
			return {
				...inventory_column,
				headerName: `Stores with Rpl. InStock < 95%`,
			};
		}
		return inventory_column;
	});
};

const retrieveTableRows = (rootCauses = [], domain) => {
	return rootCauses.find((rootCause) => rootCause.domain === domain)?.details;
};

const retrieveTableColumns = (domain) => {
	let columnsArr = [];
	if (domain === 'inventoryHealth') {
		columnsArr = `inventory_columns`;
	} else {
		columnsArr = `${domain}_columns`;
	}
	return initialState[columnsArr];
};

const retriveRootCause = (rootCauses, domain) => {
	return rootCauses.find((rootCause) => rootCause.domain === domain);
};

const updateRootCauseObject = (edges) => {
	let detailsArr = [];
	edges.map((edge) => {
		let obj = {};
		for (let item in edge.node.dimensions) {
			if (item !== '__typename') {
				obj[item] = edge.node.dimensions[item];
			}
		}
		const temp = {};
		for (let item in edge.node) {
			if (item !== '__typename' && item !== 'dimensions') {
				temp[item] = edge.node[item];
			}
		}
		const arrObj = {
			node: {
				...temp,
				...obj,
			},
		};
		detailsArr.push(arrObj);
	});
	return detailsArr;
};

const mergeTwoArr = (details, arr) => {
	const mergeArr = details.map((detail) => {
		const match = arr.find(
			(obj) => obj['wmItemNbr'] === detail.node['wmItemNbr']
		);
		if (match) {
			return {
				node: {
					...detail.node,
					...match,
				},
			};
		}
	});
	const edges = {
		edges: mergeArr,
	};
	return edges;
};

const upDateRootCauses = (rootCauses, details, domain) => {
	const rootCause = rootCauses.find((rootCause) => rootCause.domain == domain);
	const arr = updateRootCauseObject(rootCause.details.edges);
	const mergeArr = mergeTwoArr(arr, details);
	const updatedRootCauses = rootCauses.map((rootCause) => {
		if (rootCause.domain == domain) {
			rootCause.details = mergeArr;
		}
		return rootCause;
	});
	return updatedRootCauses;
};

const rcaReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		/* Initial Loading of the RCA page */
		case actionTypes.GET_RCA_DATA: {
			return {
				...state,
				loading: true,
				error: false,
				inventory_columns: resetInventoryColumns(state.inventory_columns),
				rootCauses: [],
				tableRows: [],
				tableColumns: [],
				threshold: 95,
				hierarchyId: '',
				hierarchyName: '',
				currentRootCause: '',
				supplier_share: 0,
				supplier_share_change: 0,
				net_sales: 0,
				net_sales_change: 0,
				net_sales_change_percent: 0,
				walmart_net_sales_change_percent: 0,
				units: 0,
				units_change: 0,
				units_change_percent: 0,
				walmart_units_change_percent: 0,
				avgNilPickPct: 0,
				wmNilPickRate: 0,
				inventory_avg_instock_percent: 0,
				inventory_avg_nilpick_percent: 0,
				inventory_items_oos: 0,
				inventory_potential_sales_impact: 0,
				inventory_rows: [],
				pricing_increased_in_price: 0,
				pricing_decreased_in_price: 0,
				pricing_potional_sales_impact: 0,
				pricing_rows: [],
				pod_increased_in_traited_stores: 0,
				pod_decreased_in_traited_stores: 0,
				pod_potential_sales_impact: 0,
				pod_rows: [],
				assortment_added: 0,
				assortment_removed: 0,
				assortment_potential_sales_impact: 0,
				assortment_rows: [],
				repInStockLoading: false,
				replInstockError: false,
			};
		}

		/* When the loading of the RCA page is success  */
		case actionTypes.GET_RCA_DATA_SUCCSS: {
			return {
				...state,
				supplier_share: action?.payload.concatResponseObj?.marketShare,
				supplier_share_change:
					action?.payload.concatResponseObj?.marketShareChng,
				hierarchyId: action?.payload.concatResponseObj?.id,
				hierarchyName: action?.payload.concatResponseObj?.name,

				net_sales: action?.payload?.concatResponseObj?.netSalesTY,
				net_sales_change: action?.payload?.concatResponseObj?.netSalesTYChngRef,
				net_sales_change_percent:
					action?.payload?.concatResponseObj?.netSalesTYChngPctRef,
				walmart_net_sales_change_percent:
					action?.payload?.concatResponseObj?.wmNetSalesTYChngPctRef,

				units: action?.payload?.concatResponseObj?.unitsTY,
				units_change: action?.payload?.concatResponseObj?.unitsTYChngRef,
				units_change_percent:
					action?.payload?.concatResponseObj?.unitsTYChngPctRef,
				walmart_units_change_percent:
					action?.payload?.concatResponseObj?.wmUnitsTYChngPctRef,
				avgNilPickPct: action?.payload?.concatResponseObj?.nilPikRate,
				wmNilPickRate: action?.payload?.concatResponseObj?.wmNilPickRate,
				rootCauses: action?.payload?.concatResponseObj.rootCauses,

				tableColumns: retrieveTableColumns(action?.payload?.highestRootCause),
				tableRows: retrieveTableRows(
					action?.payload?.concatResponseObj.rootCauses,
					action?.payload?.highestRootCause
				),

				pricing_rows:
					retrieveTableRows(
						action?.payload?.concatResponseObj.rootCauses,
						'pricing'
					) || [],
				inventory_rows:
					retrieveTableRows(
						action?.payload?.concatResponseObj.rootCauses,
						'inventoryHealth'
					) || [],
				pod_rows:
					retrieveTableRows(
						action?.payload?.concatResponseObj.rootCauses,
						'pod'
					) || [],
				assortment_rows:
					retrieveTableRows(
						action?.payload?.concatResponseObj.rootCauses,
						'assortment'
					) || [],

				pricing_decreased_in_price: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pricing'
				)?.priceCntDec,
				pricing_increased_in_price: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pricing'
				)?.priceCntInc,
				pricing_potional_sales_impact: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pricing'
				)?.totalSalesImpact,

				pod_increased_in_traited_stores: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pod'
				)?.traitedStoreCntInc,
				pod_decreased_in_traited_stores: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pod'
				)?.traitedStoreCntDec,
				pod_potential_sales_impact: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'pod'
				)?.totalSalesImpact,

				assortment_added: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'assortment'
				)?.addedItemCnt,
				assortment_removed: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'assortment'
				)?.removedItemCnt,
				assortment_potential_sales_impact: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'assortment'
				)?.totalSalesImpact,

				inventory_avg_instock_percent: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'inventoryHealth'
				)?.replInstkPercentageTY,
				inventory_avg_nilpick_percent: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'inventoryHealth'
				)?.nilPikRate,
				inventory_potential_sales_impact: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'inventoryHealth'
				)?.totalSalesImpact,
				inventory_items_oos: retriveRootCause(
					action?.payload?.concatResponseObj.rootCauses,
					'inventoryHealth'
				)?.itemOosCnt,

				currentRootCause: action?.payload?.highestRootCause,
				loading: false,
			};
		}

		/* When is there is error during initial loading of the rca page */
		case actionTypes.GET_RCA_DATA_FAILURE: {
			return {
				...state,
				loading: false,
				error: true,
			};
		}

		/* When you switch the root causes tab, this is to get the metrics data, */
		case actionTypes.GET_RCA_BDD_METRICS: {
			return {
				...state,
				loading: true,
				error: false,
			};
		}

		/* When you switch the root causes tab and the call to fetch the metrics data is success */
		case actionTypes.GET_RCA_BDD_METRICS_SUCCESS: {
			switch (action.payload.rootCause) {
				case INVENTORY_HEALTH:
					return {
						...state,
						tableColumns: state.inventory_columns,
						inventory_rows: retrieveTableRows(
							upDateRootCauses(
								state.rootCauses,
								action.payload.details,
								INVENTORY_HEALTH
							),
							INVENTORY_HEALTH
						),
						tableRows: retrieveTableRows(
							upDateRootCauses(
								state.rootCauses,
								action.payload.details,
								INVENTORY_HEALTH
							),
							INVENTORY_HEALTH
						),
						inventory_potential_sales_impact: retriveRootCause(
							state.rootCauses,
							'inventoryHealth'
						)?.totalSalesImpact,
						inventory_items_oos: retriveRootCause(
							state.rootCauses,
							'inventoryHealth'
						)?.itemOosCnt,
						inventory_avg_instock_percent:
							action.payload?.replInstkPercentageTY,
						inventory_avg_nilpick_percent: action.payload?.nilPikRate,
						rootCauses: upDateRootCauses(
							state.rootCauses,
							action.payload.details,
							INVENTORY_HEALTH
						),
						currentRootCause: INVENTORY_HEALTH,
						threshold: 95,
						loading: false,
					};
				case PRICING:
					return {
						...state,
						tableColumns: state.pricing_columns,
						pricing_rows: retrieveTableRows(
							upDateRootCauses(
								state.rootCauses,
								action.payload.details,
								PRICING
							),
							PRICING
						),
						tableRows: retrieveTableRows(
							upDateRootCauses(
								state.rootCauses,
								action.payload.details,
								PRICING
							),
							PRICING
						),
						rootCauses: upDateRootCauses(
							state.rootCauses,
							action.payload.details,
							PRICING
						),
						currentRootCause: PRICING,
						loading: false,
					};
				case POD:
					return {
						...state,
						tableColumns: state.pod_columns,
						pod_rows: retrieveTableRows(
							upDateRootCauses(state.rootCauses, action.payload.details, POD),
							POD
						),
						tableRows: retrieveTableRows(
							upDateRootCauses(state.rootCauses, action.payload.details, POD),
							POD
						),
						rootCauses: upDateRootCauses(
							state.rootCauses,
							action.payload.details,
							POD
						),
						currentRootCause: POD,
						loading: false,
					};
			}
			break;
		}

		/* When you switch the root causes tab and the call to fetch the metrics data is failure */
		case actionTypes.GET_RCA_BDD_METRICS_FAILURE: {
			return {
				...state,
				loading: false,
				error: true,
			};
		}

		/* When you try to update the headers and rows of the rca table*/
		case actionTypes.UPDATE_RCA_TABLE_HEADERS_AND_ROWS: {
			switch (action.payload) {
				case INVENTORY_HEALTH:
					return {
						...state,
						tableRows: state.inventory_rows,
						tableColumns: state.inventory_columns,
						currentRootCause: INVENTORY_HEALTH,
					};
				case PRICING_CHANGE:
					return {
						...state,
						tableRows: state.pricing_rows,
						tableColumns: state.pricing_columns,
						currentRootCause: PRICING_CHANGE,
					};
				case POINTS_OF_DISTRIBUTION:
					return {
						...state,
						tableRows: state.pod_rows,
						tableColumns: state.pod_columns,
						currentRootCause: POINTS_OF_DISTRIBUTION,
					};
				default:
					return {
						...state,
						tableRows: state.assortment_rows,
						tableColumns: state.assortment_columns,
						currentRootCause: ASSORTMENT,
					};
			}
		}

		/* When you try to update Repl Instock Percentage */
		case actionTypes.UPDATE_INVENTORY_ROOTCAUSE:
			return {
				...state,
				threshold: action?.payload.request.threshold,
				tableColumns: updateInventoryColumns(
					state.inventory_columns,
					action?.payload.request.threshold
				),
				repInStockLoading: true,
				replInstockError: false,
			};

		/* When you update Repl Instock Percentage and the call is success */
		case actionTypes.UPDATE_INVENTORY_ROOTCAUSE_SUCCESS:
			return {
				...state,
				tableRows: action.payload.rootCauses[0].details,
				// rootCauses: updateReplHealthRootCause(state.rootCauses, action.payload?.rootCauses[0]),
				inventory_rows: action.payload.rootCauses[0].details,
				repInStockLoading: false,
				inventory_avg_instock_percent:
					action.payload.rootCauses[0].replInstkPercentageTY,
				inventory_avg_nilpick_percent: action.payload.rootCauses[0].nilPikRate,
				inventory_potential_sales_impact:
					action.payload.rootCauses[0].totalSalesImpact,
				inventory_items_oos: action.payload.rootCauses[0].itemOosCnt,
			};

		/* When you update Repl Instock Percentage and the call is failure */
		case actionTypes.UPDATE_INVENTORY_ROOTCAUSE_FAILURE:
			return {
				...state,
				tableRows: [],
				inventory_rows: [],
				inventory_avg_instock_percent: null,
				inventory_avg_nilpick_percent: null,
				inventory_potential_sales_impact: null,
				inventory_items_oos: null,
				repInStockLoading: false,
				replInstockError: true,
			};

		case actionTypes.UPDATE_INVENTORY_ROOTCAUSE_NO_DATA_SUCCESS:
			return {
				...state,
				tableRows: [],
				inventory_rows: [],
				inventory_avg_instock_percent: null,
				inventory_avg_nilpick_percent: null,
				inventory_potential_sales_impact: null,
				inventory_items_oos: null,
				repInStockLoading: false,
				replInstockError: false,
			};

		case actionTypes.RESET_RCA_LOADING_STATE: {
			return {
				...state,
				loading: false,
			};
		}

		default:
			return state;
	}
};

export default rcaReducer;
